import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { formatMessage } from '../../lib/intl';
import { Field } from 'redux-form';
import FormField from '../form-field';

const i18n = defineMessages({
  label: {
    id: 'shareInfo.slots.label',
    defaultMessage: 'Number of {slotsName} for you',
  },
  label_adult: {
    id: 'shareInfo.slots.label_adult',
    defaultMessage: 'Number of adults for you',
  },
  label_passenger: {
    id: 'shareInfo.slots.label_passenger',
    defaultMessage: 'Number of passengers for you',
  },
  label_ticket: {
    id: 'shareInfo.slots.label_ticket',
    defaultMessage: 'Number of tickets for you',
  },
  label_seat: {
    id: 'shareInfo.slots.label_seat',
    defaultMessage: 'Number of seats for you',
  },
  label_item: {
    id: 'shareInfo.slots.label_item',
    defaultMessage: 'Number of items for you',
  },
  label_shirt: {
    id: 'shareInfo.slots.label_shirt',
    defaultMessage: 'Number of shirts for you',
  },
  label_person: {
    id: 'shareInfo.slots.label_person',
    defaultMessage: 'Number of people for you',
  },
  label_guest: {
    id: 'shareInfo.slots.label_guest',
    defaultMessage: 'Number of guests for you',
  },
  label_player: {
    id: 'shareInfo.slots.label_player',
    defaultMessage: 'Number of players for you',
  },
  label_student: {
    id: 'shareInfo.slots.label_student',
    defaultMessage: 'Number of students for you',
  },
});

class ShareInfoNumberOfSlots extends Component {
  constructor(props) {
    super(props);

    this.formatMessage = formatMessage(this.props.intl);
    this.onSlotsChange = this.onSlotsChange.bind(this);
  }

  onSlotsChange(ev) {
    return this.props.onChange(ev.target.value);
  }

  render() {
    const { purchase } = this.props;

    return (
      <div className="split-info number-of-slots">
        <div className="form-inline form-mixed">
          <div className="inline-part title bigger-title">
            {this.formatMessage(i18n.label, purchase.slotName)}
          </div>
          <div className="inline-part">
            <Field
              name="claimedSlots"
              type="number"
              max={this.props.maxSlots || 99}
              min={1}
              component={FormField}
              onChange={this.onSlotsChange}
            />
          </div>
        </div>
      </div>
    );
  }
}

ShareInfoNumberOfSlots.defaultProps = {
  maxSlots: 99,
  onChange: () => { },
  purchase: { slotName: null },
};

export default injectIntl(ShareInfoNumberOfSlots);



// WEBPACK FOOTER //
// ./src/desktop/components/commit-form/share-info.slots.js